import tippy from "tippy.js";
import jquery from "jquery";

const $ = jquery;

function initInfoDeliveryTooltip() {
    const label = document.querySelector(".js-info-delivery-tooltip-init");

    if (label && label.hasAttribute("data-announcing") && !label.classList.contains("tooltip-initialized")) {
        tippy(label, {
            placement: "top",
            maxWidth: 300,
            arrow: true,
            theme: "light",
            ignoreAttributes: true,
            trigger: "mouseenter click",
            hideOnClick: true,
            allowHTML: true,
            onCreate(instance) {
                instance.setContent(label.getAttribute("data-announcing"));
                instance.reference.removeAttribute("data-announcing");
            },
        });
        label.classList.add("tooltip-initialized");
    }
}

$(document).ajaxSuccess(() => {
    initInfoDeliveryTooltip();
});

window.addEventListener("load", initInfoDeliveryTooltip());
